module.exports = __webpack_public_path__ + "static/img/builderall-tools.4f8e882.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/config/element-category-icons/builderall-tools.svg
// module id = vdjR
// module chunks = 48